(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/views/betslip.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/views/betslip.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.components=_svs.eurojackpot.components||{};
_svs.eurojackpot.components.play=_svs.eurojackpot.components.play||{};
_svs.eurojackpot.components.play.templates=_svs.eurojackpot.components.play.templates||{};
svs.eurojackpot.components.play.templates.betslip = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id='drawDaysRegion'></div>\n<div id='drawCountRegion'></div>\n<div class='numbergames-footer-section'>\n  <div id='subscriptionInfoRegion'></div>\n  <div id='trissRegion'></div>\n  <div id='playTogetherRegion'></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-eurojackpot-components-play-betslip'] = svs.eurojackpot.components.play.templates.betslip;
})(svs, Handlebars);


 })(window);